import React from 'react';

const InformationTechnology = () => {
  return (
    <div>
      InformationTechnology
      InformationTechnology
    </div>
  );
}

export default InformationTechnology;
